import * as React from "react";
import DeleteDialogLayout from "components/DialogLayout/DeleteDialogLayout";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import repository from "client/repository";
import {AzureRegionResource} from "client/resources/azureRegionResource";
import {RegionPublicIpPrefixResource} from "client/resources/regionPublicIpPrefixResource";
import {AdministratorRoleCallout} from "shared/AdministratorRoleCallout";

interface Props {
    azureRegion: AzureRegionResource;
    prefix: RegionPublicIpPrefixResource;
    onTaskStarted: (taskId: string) => void;
}

type State = DataBaseComponentState;

class DeleteRegionPublicIpPrefixDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        return <DeleteDialogLayout title="Delete IP Prefix"
                                   busy={this.state.busy}
                                   errors={this.state.errors}
                                   onDeleteClick={this.delete}>
            <AdministratorRoleCallout action="delete an IP prefix"/>
            <p>Are you sure you want to delete the <b>{this.props.prefix.Name}</b> ({this.props.prefix.IpPrefix}) IP prefix?</p>
            <p>It will be deleted from Azure and removed from the {this.props.azureRegion.Region} Azure Region. Its IP addresses are released and can't be recovered. It can only be deleted while no IP addresses are allocated from it.</p>
        </DeleteDialogLayout>;
    }

    private delete = (): Promise<boolean> => {
        return this.doBusyTask(async () => {
            const taskId = await repository.AzureRegions.deletePublicIpPrefix(this.props.azureRegion.Id, this.props.prefix.Name);
            this.props.onTaskStarted(taskId);
        });
    }
}

export default DeleteRegionPublicIpPrefixDialog;
